import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Input } from '@angular/core';
import { RootReducer, Store } from '@app/app.reducers';
import { getShowPricesWithTax } from '@app/checkout/modules/checkout-shared/reducers/checkout.reducer';
import { ProductPriceRequest } from '@app/product/reducers/product.reducer';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';

/** Product Price Component */
@Component({
	selector: 'g-product-price',
	templateUrl: './product-price.component.html',
	styleUrls: ['./product-price.component.scss'],
	animations: [
		trigger('spinnerTrigger', [
			transition(':enter', [style({ opacity: 0 }), animate('100ms 200ms', style({ opacity: 1 }))]),
			transition(':leave', [animate('100ms', style({ opacity: 0 }))]),
		]),
	],
})
export class ProductPriceComponent {
	@Input() readonly price?: ProductPriceRequest | null;
	@Input() readonly isVariableProduct = false;
	readonly icons = { faSpinner };
	constructor(private readonly store: Store<RootReducer.State>) {}
	readonly showPricesWithTax$ = this.store.select(getShowPricesWithTax);
}
